var app = angular.module('leonardo');

var AccountSystemService = function(BaseRestService, $q, AuthService, RestangularProvider) {
  var service = new BaseRestService('admin-user', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('admin-user', false, function(accountUser) {
      accountUser.addRestangularMethod('deleteReportTo', 'post', 'delete');
      accountUser.addRestangularMethod('unDelete', 'post', 'undelete');
      return accountUser;
    });
  });

  service.getReports = function(params) {
    return RestangularProvider.all('admin-user').customGET('report', params);
  };

  service.getAvailableToAssign = function(params) {
    return RestangularProvider.all('admin-user').customGET('available-users-to-assign', params);
  };

  service.acceptAllAudits = function(params) {
    return RestangularProvider.all('admin-user').customPOST(params, 'templates-audit/accept');
  };

  service.rejectAllAudits = function(params) {
    return RestangularProvider.all('admin-user').customPOST(params, 'templates-audit/reject');
  };

  service.getUsersReportTo = function(account_user, params) {
    return RestangularProvider.one('admin-user', account_user).customGET('available-report-to', params);
  };

  service.TYPE_OWNER = '0';
  service.TYPE_REGIONAL = '1';
  service.TYPE_PROPERTY = '2';
  service.TYPE_MANAGER = '3';
  service.TYPE_VENDOR = '4';

  service.TYPE_OPTIONS = [
    service.TYPE_OWNER,
    // service.TYPE_REGIONAL,
    service.TYPE_PROPERTY,
    service.TYPE_MANAGER,
    service.TYPE_VENDOR
  ];

  service.ARRAY_TYPE_OPTIONS = [
    {id: service.TYPE_OWNER, name: 'Owner'},
    // {id: service.TYPE_REGIONAL, name: 'Regional Manager'},
    {id: service.TYPE_PROPERTY, name: 'Manager'},
    {id: service.TYPE_MANAGER, name: 'Site Staff'}
  ];

  service.GENDER_MALE = '0';
  service.GENDER_FEMALE = '1';

  service.GENDER_OPTIONS = [
    {id: service.GENDER_MALE, name: 'Male'},
    {id: service.GENDER_FEMALE, name: 'Female'}
  ];

  service.STATUS_ACTIVE = '1';
  service.STATUS_DEACTIVATED = '0';

  service.STATUS_OPTIONS = [
    {id: service.STATUS_ACTIVE, name: 'Active Users'},
    {id: service.STATUS_DEACTIVATED, name: 'Disabled Users'}
  ];

  service.currentAccountUser = null;

  service.get = function(id) {
    var defer = $q.defer();
    RestangularProvider.one('admin-user', id).customGET('').then(function(data){
      data.deleteReportTo = function(params) {
        return RestangularProvider.one('admin-user', this.id).customPOST(params, 'delete');
      };
      data.unDelete = function() {
        return RestangularProvider.one('admin-user', this.id).customPOST({}, 'undelete');
      };
      data.patch = function(params) {
        return RestangularProvider.one('admin-user', this.id).patch(params);
      };
      data.remove = function(params) {
        return RestangularProvider.one('admin-user', this.id).remove(params);
      };
      defer.resolve(data);
    }, function (error) {
      defer.reject(error);
    });
    return defer.promise;
  };

  service.getlist = function(params) {
    var defer = $q.defer();
    RestangularProvider.all('admin-user').customGET('', params).then(function(data){
      angular.forEach(data.results, function(account_user){
        account_user.deleteReportTo = function() {
          return RestangularProvider.one('admin-user', this.id).customPOST({}, 'delete');
        };
        account_user.unDelete = function() {
          return RestangularProvider.one('admin-user', this.id).customPOST({}, 'undelete');
        };
        account_user.patch = function(params) {
          return RestangularProvider.one('admin-user', this.id).patch(params);
        };
        account_user.remove = function(params) {
          return RestangularProvider.one('admin-user', this.id).remove(params);
        };
      });
      defer.resolve(data);
    }, function (error) {
      defer.reject(error);
    });
    return defer.promise;
  };

  service.getCurrentPermissions = function(params) {
    return RestangularProvider.one('user', this.currentAccountUser.user.id).customGET('permissions', params);
  };

  service.getCurrentAccountUser = function (list) {
    var account_user = null;
    angular.forEach(list, function (element) {
      if (!element.managed_by) {
        account_user = element;
      }
    });
    return account_user;
  };

  service.getCurrent = function() {
    var token = AuthService.getDecodedToken();
    var defer = $q.defer();
    service.getlist({user: token.user_id}).then(function(list) {
      var results = list.results ? list.results: list;
      service.currentAccountUser = service.getCurrentAccountUser(results);
      service.getCurrentPermissions().then(function (data) {
        service.currentAccountUser.permissions = data.results ? data.results : data;
      });
      defer.resolve(service.currentAccountUser);
    }, function(){
      defer.resolve({});
    });
    return defer.promise;
  };
  return service;
};

var AccountUserActivityService = function(BaseRestService, RestangularProvider) {

  var service = new BaseRestService('admin-user-activity');

  service.getReports = function(params) {
    return RestangularProvider.all('admin-user-activity').customGET('report', params);
  };

  service.getReportsOnDemand = function(params) {
    return RestangularProvider.all('admin-user-activity').customGET('on-demand-instruction/access-report', params);
  };

  return service;
};

app.factory('AccountSystemService', ['BaseRestService', '$q', 'AuthService', 'Restangular', AccountSystemService]);
app.factory('AccountUserActivityService', ['BaseRestService', 'Restangular', AccountUserActivityService]);
